import { KlaviyoEventType } from "@redotech/redo-integrations-definitions-common/klaviyo-integration";
import { ReturnTrackingTriggerKey } from "@redotech/redo-model/advanced-flow/triggers";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

const smsSignupForwarding = z.object({
  enabled: z.boolean(),
  listId: z.string().nullish(),
  customSource: z.string().nullish(),
});

export const updateKlaviyoIntegration = {
  name: "updateKlaviyoIntegration" as const,
  input: z.object({
    events: z.array(createEnum(KlaviyoEventType)).optional(),
    returnTrackingTriggers: z
      .array(createEnum(ReturnTrackingTriggerKey))
      .optional(),
    smsSignupForwarding: smsSignupForwarding.optional(),
  }),
  output: z.object({}),
};

export type UpdateKlaviyoIntegrationInput = z.infer<
  typeof updateKlaviyoIntegration.input
>;

export const setKlaviyoIntegration = {
  name: "setKlaviyoIntegration" as const,
  input: z.object({
    privateApiKey: z.string().min(1, "API key is required"),
    events: z.array(createEnum(KlaviyoEventType)).optional(),
    returnTrackingTriggers: z
      .array(createEnum(ReturnTrackingTriggerKey))
      .optional(),
    smsSignupForwarding: smsSignupForwarding.optional(),
  }),
  output: z.object({}),
};

export type SetKlaviyoIntegrationInput = z.infer<
  typeof setKlaviyoIntegration.input
>;

export const getKlaviyoIntegration = {
  name: "getKlaviyoIntegration" as const,
  input: z.object({}),
  output: z.object({
    klaviyoIntegration: z.optional(
      z.object({
        events: z.array(createEnum(KlaviyoEventType)),
        returnTrackingTriggers: z.array(createEnum(ReturnTrackingTriggerKey)),
        // Optional so a new client validating an old server's response during
        // the deploy window doesn't fail the whole settings page.
        smsSignupForwarding: smsSignupForwarding.optional(),
      }),
    ),
  }),
};

export const getKlaviyoLists = {
  name: "getKlaviyoLists" as const,
  input: z.object({}),
  output: z.object({
    lists: z.array(
      z.object({
        id: z.string(),
        name: z.string(),
        optInProcess: z.string().nullish(),
      }),
    ),
  }),
};

export type GetKlaviyoListsOutput = z.infer<typeof getKlaviyoLists.output>;

export type GetKlaviyoIntegrationOutput = z.infer<
  typeof getKlaviyoIntegration.output
>;

export const disconnectKlaviyoIntegration = {
  name: "disconnectKlaviyoIntegration" as const,
  input: z.object({}),
  output: z.object({}),
};

export const sendTestKlaviyoEvents = {
  name: "sendTestKlaviyoEvents" as const,
  input: z.object({
    triggers: z.array(createEnum(ReturnTrackingTriggerKey)).min(1),
    email: z.email(),
  }),
  output: z.object({
    sent: z.number(),
    failures: z.array(
      z.object({
        trigger: createEnum(ReturnTrackingTriggerKey),
        error: z.string(),
      }),
    ),
  }),
};

export type SendTestKlaviyoEventsInput = z.infer<
  typeof sendTestKlaviyoEvents.input
>;
